export default __webpack_public_path__ + "static/media/rsm.5caf09b9.png";